import React from 'react';
import { createContext } from 'react';

export const LayoutDataContext = createContext({});

const LayoutDataContextProvider = ({ children, data }) => (
  <LayoutDataContext.Provider value={{ data }}>
    {children}
  </LayoutDataContext.Provider>
);

export default LayoutDataContextProvider;